import { Inject, Injectable, Optional } from '@angular/core';
import { Observable, of } from 'rxjs';
import { FeatureFlagService } from '@galaxy/partner';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { SENDER_INJECTION_TOKEN } from '../shared';
import { Sender, SenderType } from '@vendasta/email';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagEnabledService {
  constructor(
    @Inject(SENDER_INJECTION_TOKEN) @Optional() private readonly sender$: Observable<Sender>,
    private readonly featureFlagService: FeatureFlagService,
  ) {}

  public isEnabled(featureFlagIds: string): Observable<boolean> {
    let flagEnabled$ = of(false);
    if (this.sender$) {
      flagEnabled$ = this.sender$.pipe(
        switchMap((sender) => {
          if (sender.type === SenderType.SENDER_TYPE_PARTNER) {
            return this.featureFlagService.batchGetStatus(sender.id, '', [featureFlagIds]);
          }
          return of({});
        }),
        map((featureFlagStatus) => featureFlagStatus[featureFlagIds]),
        shareReplay(1),
      );
    }
    return flagEnabled$;
  }
}
